// Moving a visible edge also crosses any omitted slots beyond it. This keeps the
// pitch sequence and every other visible note on its original string.
export const boundaryTransferCount = (chart, from, to, noteId) => {
  const counts = chart.notesPerString;
  if (!Number.isInteger(from) || !Number.isInteger(to) || Math.abs(from - to) !== 1 ||
      from < 0 || to < 0 || from >= counts.length || to >= counts.length) return 0;
  const start = counts.slice(0, from).reduce((sum, count) => sum + count, 0);
  const end = start + counts[from];
  const omitted = new Set(chart.omittedNotes || []);
  const up = to > from;
  let edge = up ? end - 1 : start;
  const step = up ? -1 : 1;
  while (edge >= start && edge < end && omitted.has(edge)) edge += step;
  if (edge < start || edge >= end || (noteId !== undefined && noteId !== edge)) return 0;
  const amount = up ? end - edge : edge - start + 1;
  return counts[to] + amount <= 8 ? amount : 0;
};
